export default __webpack_public_path__ + "static/media/B0000.0f866ee5.png";